module.exports = ".footer{padding:5px}.footer .head{font-weight:500;text-transform:uppercase}.footer .detail .bold{font-weight:500;padding-left:6px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.sass
// module id = ./src/app/layout/footer/footer.component.sass
// module chunks = main